import { useMemo } from 'react';

import {
  FieldNames,
  IFRAME_FIELDS,
  PaymentMethodInput,
} from '@cashier/cashier-model';

const iframesCollection = new Set<FieldNames>(IFRAME_FIELDS);

export const useHostedFieldSchema = ({
  activeInputs,
}: {
  activeInputs: PaymentMethodInput[];
}): Map<FieldNames, PaymentMethodInput> => {
  return useMemo(() => {
    const workingFields = activeInputs.filter((el) =>
      iframesCollection.has(el?.name as FieldNames),
    );
    return new Map(
      workingFields.map((field) => [field.name as FieldNames, field]),
    );
  }, [activeInputs]);
};
